import React, { useEffect, useRef, useState } from 'react'
import styles from '../modalComponent.module.scss'
import Flexxi from '../../../../../icons/flexiiLogo.svg'
import { setAdditionalEmail } from '../../../../../redux/actions/quizQuestions'
import { useDispatch, useSelector } from 'react-redux'
import emailValidator from '../../../../../utils/validators/emailValidator'
import {
  setResetEmailFormValidation,
  setSignInWithEmailFormValidation,
} from '../../../../../redux/actions/validation'
import { setUserEmail } from '../../../../../redux/actions/authActions'
import ErrorMessageComponent from '../../../../ReusableField/ErrorMessageComponent'
import Input from '../../../../UiKitComponents/Input'
import { setPdfEmail } from '../../../../../redux/actions/pdfInputEmail'
import { setConfirmationModalForm } from '../../../../../redux/actions/confirmationModal'
const AddEmailComponent = () => {
  const {
    validation: {
      signInWithEmailFormValidation: { emailErr },
    },
  } = useSelector((state) => state)
  const dispatch = useDispatch()

  const validationEmail = (field, value) => {
    let inValid = false
    if (!value) {
      inValid = true
      dispatch(
        setSignInWithEmailFormValidation(field + 'Err', 'E-Mail ist erforderlich'),
      )
    } else if (!emailValidator(value)) {
      inValid = true
      dispatch(
        setSignInWithEmailFormValidation(field + 'Err', 'E-Mail ist erforderlich'),
      )
      // setErrorMessage('Falsche E-Mail oder Passwort')
    }
    return inValid
  }
  const handleChangeEmail = (field, value) => {
    dispatch(setSignInWithEmailFormValidation(field + 'Err', null))
    emailValidator(value) && dispatch(setPdfEmail(value))
    emailValidator(value)
      ? dispatch(
          setConfirmationModalForm({
            isInValid: false,
          }),
        )
      : dispatch(
          setConfirmationModalForm({
            isInValid: true,
          }),
        )
  }
  const handleBlurEmailField = (field, value) => {
    validationEmail(field, value)
  }
  return (
    <div className={styles.addEmailComponent}>
      <div>
        <img src={Flexxi} alt={Flexxi} />
        <p>Hier können Sie weitere E-Mail-Adressen hinzufügen.</p>
      </div>
      <div>
        <Input
          // ref={inputRef}
          type={'text'}
          // value={inputValue}
          placeholder={'Geben Sie eine Antwort ein.'}
          validationMessage={emailErr}
          onChange={(e) => handleChangeEmail('email', e.currentTarget.value)}
          onBlur={(e) => handleBlurEmailField('email', e.currentTarget.value)}
        />
      </div>
    </div>
  )
}
export default AddEmailComponent
